import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {ProjectMembersListingModalTypes} from '../../interfaces'
import useGetProjectMembersList from '../../hooks/useGetProjectMembersList'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import Initials from '../../../../components/Initials'
import {projectMembersListingModalColumns} from '../../utils'

const ProjectMembersListingModal = ({
  show,
  onClose,
  projectId,
}: ProjectMembersListingModalTypes) => {
  const {projectMembersList, isLoading} = useGetProjectMembersList(projectId)

  return (
    <ConfirmationModal
      show={show}
      onClose={onClose}
      title={'Project Members'}
      bodyClass='mh-550px overflow-auto'
      body={
        <DynamicTable
          data={projectMembersList}
          sortableColumns={projectMembersListingModalColumns}
          loading={isLoading}
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          noDataMessage='No project members found'
          TableRow={({row}: any) => {
            return (
              <tr className={!row?.is_active ? 'opacity-50 bg-light-danger' : ''}>
                <td>
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-circle symbol-40px me-3'>
                      <Initials text={row?.name?.charAt(0)?.toUpperCase()} />
                    </div>
                    <div className='d-flex flex-column justify-content-center'>
                      <div className='d-flex align-items-center'>
                        <span className='fw-bold fs-6'>{row?.name}</span>
                        {row?.is_owner && (
                          <span className={`ms-2 badge badge-lg badge-light-primary`}>
                            <div className='align-items-center'>Owner</div>
                          </span>
                        )}
                      </div>
                      <span className='text-gray-600'>{row?.username}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className='text-end'>
                    <span className='fs-6'>{row?.role}</span>
                  </div>
                </td>
              </tr>
            )
          }}
        />
      }
    />
  )
}

export default ProjectMembersListingModal
